import * as Cookies from 'js-cookie';

/**
 * @global l10n WordPress localization
 */
export default class Favorites {
  constructor(type = 'lot-selector', limit = null) {
    /**
     * Type of selector
     * 
     * @type {String}
     */
    this.type = type;

    /**
     * Amount of favorites that a user can have
     * 
     * @type {Number}
     */
    this.limit = limit;

    /**
     * Name of the cookie for the chosen favorites
     * 
     * @type {String}
     */
    this.cookieName = `${type}-favorites`;

    /**
     * User defined favorites
     * 
     * @type {Array}
     */
    this.favorites = [];

    /**
     * Authentication status
     * 
     * @type {Object}
     */
    this.authStatus = null;

    /**
     * Selectors
     */
    this.els = {};
    this.els.lots = $('.lot-selector-area, .overview-item, .lot-modal');
    this.els.filter = $('.filter-favorites');
    this.els.favoriteButtons = $('.favorite-lot');

    this.init();
  }

  /**
   * Initialize all event listeners
   */
  init() {
    /**
     * User favorites a lot
     * 
     * @listens click
     */
    $('body').on('click', '.favorite-lot[data-lot-id]:not([disabled])', e => this.handleFavoriteClick(e));

    /**
     * User wants to get a list of their favorites
     * 
     * @listens change
     */
    this.els.filter.on('click', (e) => {
      $(e.currentTarget).toggleClass('active');
      const checked = $(e.currentTarget).hasClass('active');
      Favorites.filterFavorites(e);
      
      if (checked) {
        $('label[for=filter-favorites]').html(l10n.all_lots);
      } else {
        $('label[for=filter-favorites]').html(l10n.my_favorites);
      }

      Cookies.set('filter-favorites', checked);
    });

    // Check authentication status and show/hide favorite buttons
    this.checkAuthStatus();

    // Retrieve favorites
    if (Cookies.get(this.cookieName)) {
      this.favorites = JSON.parse(Cookies.get(this.cookieName));
      this.updateFavorites();
    }
    
    if (Cookies.get('filter-favorites')) {
      if (this.els.filter.length) {
        this.els.filter[0].checked = true;
        this.els.filter.trigger('change');
      }
    }
  }

  /**
   * Check authentication status via AJAX
   */
  checkAuthStatus() {
    $.ajax({
      method: 'POST',
      url: wp.ajax_url,
      data: {
        action: 'check_auth_status',
      },
      success: (response) => {
        if (response.success) {
          this.authStatus = response.data;
          this.showHideFavoriteButtons();
        }
      },
      error: () => {
        // On error, hide all buttons that require auth
        this.hideUnauthenticatedButtons();
      },
    });
  }

  /**
   * Show or hide favorite buttons based on authentication status
   */
  showHideFavoriteButtons() {
    this.els.favoriteButtons.each((index, button) => {
      const $button = $(button);
      const requiresAuth = $button.data('requires-auth') === 'true';

      if (requiresAuth && !this.authStatus.is_authenticated) {
        $button.hide();
      } else {
        $button.show();
      }
    });
  }

  /**
   * Hide buttons that require authentication when auth check fails
   */
  hideUnauthenticatedButtons() {
    this.els.favoriteButtons.each((index, button) => {
      const $button = $(button);
      const requiresAuth = $button.data('requires-auth') === 'true';
      
      if (requiresAuth) {
        $button.hide();
      } else {
        $button.show();
      }
    });
  }
  
  /**
   * Handle the event for the user favoriting a lot
   * 
   * @param {Object} e 
   */
  handleFavoriteClick(e) {
    this.favoriteLot(e);
    this.updateCookies();
    this.updateFavorites();
    this.updateUserMeta();
  }

  /**
   * Favorite a lot
   * 
   * @param {Object} e 
   */
  favoriteLot(e) {
    const target = $(e.currentTarget);
    const lotId = target.data('lot-id');

    if (!this.favorites.includes(lotId)) {
      if (!this.limitReached()) {
        this.favorites.push(lotId);
      }
    } else {
      // Remove favorite if already in user's favorites
      this.favorites = this.favorites.filter(value => value !== lotId);
    }
  }

  /**
   * Update client's cookies with the current set of lot IDs
   * 
   * @return {void}
   */
  updateCookies() {
    Cookies.set(this.cookieName, this.favorites, { expires: 365 });
  }

  /**
   * Visually update all the lot items on the page
   */
  updateFavorites() {
    const self = this;
    const limitReached = this.limitReached();

    const favoritedLotElements = this.els.lots.filter(function filterFavorites() {
      const lotId = $(this).data('lot-id');

      return self.favorites.includes(lotId);
    });

    this.els.lots.removeClass('favorited');
    favoritedLotElements.addClass('favorited');

    if (limitReached) {
      $('.lot-selector-area:not(.favorited) .favorite-lot-btn, .overview-item:not(.favorited) .favorite-lot-btn')
        .attr('disabled', true)
        .attr('title', l10n.favorites_limit.replace('%s', this.limit));
    } else {
      $('.lot-selector-area:not(.favorited) .favorite-lot-btn[disabled], .overview-item:not(.favorited) .favorite-lot-btn[disabled]')
        .attr('title', l10n.save)
        .removeAttr('disabled');
    }

    /* eslint-disable no-underscore-dangle */
    // Remove all tippy poppers favorite classes
    this.els.lots.each((index, element) => {
      if (Object.prototype.hasOwnProperty.call(element, '_tippy')) {
        const tippy = element._tippy;
        tippy.popper.classList.remove('favorited');

        if (limitReached) {
          $('.favorite-lot-btn', tippy.popper)
            .attr('disabled', true)
            .attr('title', l10n.favorites_limit.replace('%s', this.limit));
        } else {
          $('.favorite-lot-btn', tippy.popper)
            .removeAttr('disabled')
            .attr('title', l10n.save);
        }
      }
    });

    // Add favorited class to all connected tippy poppers
    favoritedLotElements.each((index, element) => {
      if (Object.prototype.hasOwnProperty.call(element, '_tippy')) {
        const tippy = element._tippy;
        tippy.popper.classList.add('favorited');

        $('.favorite-lot-btn', tippy.popper)
          .removeAttr('disabled')
          .attr('title', l10n.save);
      }
    });
    /* eslint-enable no-underscore-dangle */
  }

  limitReached() {
    return this.limit && this.favorites.length >= this.limit;
  }

  /**
   * Filters list of lots by user's favorites
   * 
   * @param {object} e 
   * @return {void}
   */
  static filterFavorites(e) {
    const filter = e.currentTarget;
    const filtered = $(filter).hasClass('active');

    $('.lot-selector, .lots-overview').toggleClass('show-favorites', filtered);
  }

  /**
   * Call PHP method 'save_favorites'
   */
  updateUserMeta() {
    $.ajax({
      method: 'POST',
      url: wp.ajax_url,
      data: {
        action: 'save_favorites',
        type: this.type,
        cookie: this.cookieName,
      },
    });
  }
}
